import axios, { Axios, isAxiosError } from 'axios';
import { signOut } from 'next-auth/react';

const axiosInstance: Axios = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_BACKEND_URL || ''}`,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: [
    (data) => {
      return JSON.stringify(data);
    },
  ],
  transformResponse: [
    (data) => {
      return JSON.parse(data);
    },
  ],
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (isAxiosError(error) && error.response?.status === 403) {
      const detail: string = error.response.data?.detail || '';
      const isAuthError =
        detail.includes('token') ||
        detail.includes('Invalid authentication') ||
        detail.includes('authorization code');
      if (isAuthError && typeof window !== 'undefined') {
        await signOut({ callbackUrl: '/auth/login' });
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
